import styles from "../styles/PayWidget.module.css";

// Функция для форматирования суммы
const formatAmount = (amount) => {//, currencyCode) => {
    if (!amount) return "0.00";

    const locale = "en-US"; 
/*    let currencySymbol;

    switch (currencyCode) {
        case 643:
            currencySymbol = "₽"; 
            break;
        case 978:
            currencySymbol = "€"; 
            break;
        case 840:
            currencySymbol = "$"; 
            break;
        default:
            currencySymbol = "$"; // Значение по умолчанию 
    }
*/
    return new Intl.NumberFormat(locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(amount);// + ` ${currencySymbol}`;
};

export const OrderDetails = ({ order }) => {
    // Определяем язык на основе валюты
    const isRussian = order?.order_currency === 643;

    return (
        <div className={styles.orderDetails}>
            <h2 className={styles.title}>
                {isRussian ? "Оплата заказа:" : "Order Payment:"}
            </h2>
            <p className={styles.orderId}>{order?.order_description}</p>
            <h1 className={styles.amount}>
                <strong>{order?.order_summ ? formatAmount(order.order_summ / 100) : "0.00"}</strong>{" "}
                <span style={{ fontWeight: "normal" }}>{order?.currency_symbol}</span>
            </h1>
            <hr className={styles.separator} />
        </div>
    );
};

export default OrderDetails;
